import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/imports/Page";

export const PATH = "/settings/imports";

const Home: NextPage = () => (
	<>
		<NskHead title="過去データ取込" />
		<Component />
	</>
);

export default Home;
